import { formatPercentage, getScoreColor, Text } from 'react-common'
import { useTranslation } from 'react-i18next'
import cn from 'classnames'
import { CertificateRecord } from '@/api/models/certificate-record'
import styles from './CurrentResult.module.scss'

type Props = {
  certificateRecord: CertificateRecord
}

export const CurrentResult = ({ certificateRecord }: Props) => {
  const { t } = useTranslation()

  const { normalizedPassingScore, objectiveRecord } = certificateRecord || {}
  const { score, maxScore, normalizedScore, grade } = objectiveRecord || {}

  // TODO: when backend sends grading scale, use it in here
  const scoreColor = getScoreColor(certificateRecord.objectiveRecord)

  const isSpecialScoreFormat = maxScore === 1
  const percentageScoreFormat = t('courseDetails.certificates.percentageScoreFormat', { normalizedScore })
  const commonScoreFormat = t('courseDetails.certificates.commonScoreFormat', { score, maxScore })

  const passingScorePercentage = formatPercentage(normalizedPassingScore ?? 0)

  return (
    <div className={cn(styles.certificateResults, { [styles.withGrade]: !!grade })}>
      <div className={styles.resultBox}>
        <Text.Body>{t('courseDetails.certificates.score')}</Text.Body>
        <Text.H2 className={styles.resultText} color={scoreColor}>
          {percentageScoreFormat}
        </Text.H2>
        {!isSpecialScoreFormat && <Text.Caption className={styles.scoreFormat}>{commonScoreFormat}</Text.Caption>}
      </div>
      {grade && (
        <div className={styles.resultBox}>
          <Text.Body>{t('courseDetails.certificates.grade')}</Text.Body>
          <Text.H2 className={styles.resultText} color={scoreColor}>
            {grade}
          </Text.H2>
        </div>
      )}
      <div className={styles.resultBox}>
        <Text.Body>{t('courseDetails.certificates.passingScore')}</Text.Body>
        <Text.H2 className={styles.resultText}>{passingScorePercentage}</Text.H2>
      </div>
    </div>
  )
}
